function AuthService($window, $q, $rootScope, AppSettings) {
  'ngInject';

  const service = {};

  service._user = null;

  service.getUser = function () {
    return JSON.parse($window.sessionStorage.getItem('user'))
  };

  service.setUser = function (u) {
    $window.sessionStorage.setItem('user', JSON.stringify(u));
  };

  service.getInfo = function () {
    return JSON.parse($window.sessionStorage.getItem('info'))
  };

  service.setInfo = function (u) {
    $window.sessionStorage.setItem('info', JSON.stringify(u));
  };

  service.setCurrentUser = function (u) {
    service._user = u;
    $rootScope.userInfo = u;
    $window.sessionStorage.setItem(AppSettings.appName, JSON.stringify(u));    // sessionStorage 에도 저장
    $window.sessionStorage.setItem('user', JSON.stringify(u));    // sessionStorage 에도 저장
  };

  service.removeCurrentUser = function () {
    service._user = null;
    $window.sessionStorage.removeItem(AppSettings.appName);  // sessionStorage 에서도 삭제
  };

  service.currentUser = function () {
    const d = $q.defer();
    if (service._user) {   // _user 에 정보가 있는 경우
      d.resolve(service._user);
    }
    // _user 에는 없지만 sessionStorage 에 있는 경우
    else if ($window.sessionStorage.getItem(AppSettings.appName) && $window.sessionStorage.getItem(AppSettings.appName) != 'null') {
      const user = JSON.parse($window.sessionStorage.getItem(AppSettings.appName));
      service.setCurrentUser(user);
      d.resolve(service._user);
    } else {
      d.reject(null);
    }
    return d.promise;
  };

  return service;

}

export default {
  name: 'AuthService',
  fn: AuthService
};
